// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/recency.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/recency/recency-count.js';
import g1 from '../lessons/air-law/recency/recency.js';

mount([g0, g1]);
